import { SET_AUTH } from '../store/AuthSlice';
import { useDispatch } from 'react-redux';
import { IUserResponsesType } from '../types'
import { APP_AUTH_CONST } from 'constant';
import { Encrypt } from './EncryptDecrypt';

function AuthStoreHook() {
    const dispatch = useDispatch()
    const StoreAuthUser = (data: IUserResponsesType) => {
        dispatch(SET_AUTH(data))
        let CryptoToken = Encrypt(JSON.stringify(data))
        if (CryptoToken) {
            localStorage.setItem(APP_AUTH_CONST, CryptoToken);
        }
    }
    return { StoreAuthUser }
}

export default AuthStoreHook